import { tl } from '../../../services/i18nService';
import urlUtil from '../../../util/url/urlUtil';
import { CommonRootState, StoreManager } from '../../../store/typings';
import { NavigationData, NavigationDirection } from '../types';
import commonNavigationService from '../../../services/commonNavigationService';
import { FeatureNamespace } from '../../../services/featureService';

type HotKeys = {
    [key in NavigationDirection]: any;
};

const hotKeys: HotKeys = {
    upDown: {
        next: 40,
        prev: 38,
    },
    leftRight: {
        next: 39,
        prev: 37,
    },
};
let store: StoreManager;
const navigationService: any = {
    featureId: null,
    navigationDataListeners: {},
    setupNavigationDataListeners(navigationData: NavigationData) {
        if (this.navigationDataListeners[navigationData.id]) {
            this.removeNavigationDataSupport(navigationData.id);
        }
        this.navigationDataListeners[navigationData.id] = (event: KeyboardEvent) => {
            this.handleNavigation(event, navigationData);
        };
        window.addEventListener('keydown', this.navigationDataListeners[navigationData.id]);
    },
    handleNavigation(event: KeyboardEvent, navigationData: NavigationData) {
        const { context } = store.getState() as CommonRootState;
        const key = event.keyCode;
        const navigation = hotKeys[navigationData.navigationDirection];
        if (event.altKey && navigation.next === key) {
            event.preventDefault();
            commonNavigationService.navigateToNext(context, navigationData.hits, navigationData.dataType);
        }
        if (event.altKey && navigation.prev === key) {
            event.preventDefault();
            commonNavigationService.navigateToPrevious(context, navigationData.hits, navigationData.dataType);
        }
    },
    removeNavigationDataSupport(navigationId: string) {
        window.removeEventListener('keydown', this.navigationDataListeners[navigationId]);
        this.navigationDataListeners[navigationId] = undefined;
    },
    removeKeyboardSupport() {
        Object.keys(this.navigationDataListeners).forEach((navigationId: string) => this.removeNavigationDataSupport(navigationId));
    },
    getCaptionForButtonTooltip(
        dataType: string,
        navigationDirection: string,
        autoNavigationIsEnabled: boolean,
        featureNamespace: FeatureNamespace,
        isFilterApplied?: boolean,
    ) {
        let caption = '';
        const markingFlow = urlUtil.getUrlParam('markingFlow');
        const isMarkByQuestion = markingFlow === 'question';
        const isCandidate = dataType === 'GRADING_PARTY';

        if (isFilterApplied) {
            const nextPrev = (navigationDirection === 'down' || navigationDirection === 'right')
                ? tl('grading.footer.navigationFilters.next')
                : tl('grading.footer.navigationFilters.previous');
            const filterType = isCandidate ? 'candidate' : 'question';
            const suffix = (isMarkByQuestion && isCandidate) ? 'CandidateFilter' : 'Filter';
            const filterLabel = (isMarkByQuestion && isCandidate)
                ? tl('grading.footer.navigationFilters.filterLabel.matchesCandidateFilter')
                : tl('grading.footer.navigationFilters.filterLabel.matchesFilter');
            const arrow = tl(`grading.footer.navigationFilters.${navigationDirection}Arrow`);

            caption = tl(`${featureNamespace}.footer.navigationFilters.${filterType}${suffix}`, {
                nextPrev,
                filterLabel,
                arrow,
            });
        } else {
            const navigateKey = `${featureNamespace}.footer.navigationButtons.navigateTo.${navigationDirection}.${dataType}`;
            caption = tl(navigateKey);
        }

        if (autoNavigationIsEnabled) {
            const autoText = tl(`${featureNamespace}.footer.navigationButtons.navigateTo.autoAdvanceModeEnabled`);
            caption = caption ? `${caption}, ${autoText}` : autoText;
        }

        return caption;
    },
};

export const initializeFooterNavigationService = (appStore: StoreManager) => {
    store = appStore;
};


export default navigationService;
